import { ref } from 'vue'
import { apiService } from '../services/api.js'
import { useTelegramData } from './useTelegram.js'

// Глобальное состояние уведомления
const notificationMessage = ref(null)
const notificationMessageId = ref(null)
const notificationUserId = ref(null) // Сохраняем userId при получении сообщения

export function useNotification() {
  const { userData } = useTelegramData()

  const checkForMessages = async () => {
    try {
      const userId = userData.value?.id
      if (!userId) {
        console.log('[useNotification] User ID not available yet')
        return
      }

      const userDataResponse = await apiService.getUserData(userId)

      if (userDataResponse.ok && userDataResponse.data) {
        const responseData = userDataResponse.data
        const userDataObj = responseData.user || responseData

        // Проверяем наличие messages (массив сообщений)
        if (userDataObj.messages && Array.isArray(userDataObj.messages) && userDataObj.messages.length > 0) {
          const firstMessage = userDataObj.messages[0]
          if (firstMessage && firstMessage.message) {
            notificationMessage.value = firstMessage.message
            notificationMessageId.value = firstMessage.id || null
            notificationUserId.value = String(userId) // Сохраняем userId как строку
            console.log('[useNotification] Message found and set:', {
              message: firstMessage.message,
              messageId: firstMessage.id,
              userId: notificationUserId.value,
              notificationMessageId: notificationMessageId.value
            })
            return true
          }
        }
      }
    } catch (error) {
      console.error('Error checking for messages:', error)
    }
    return false
  }

  const closeNotification = async () => {
    // Используем сохраненный userId или пытаемся получить из userData
    const userId = notificationUserId.value || userData.value?.id
    const messageId = notificationMessageId.value
    
    console.log('[useNotification] closeNotification called:', {
      userId,
      messageId,
      savedUserId: notificationUserId.value,
      userData: userData.value,
      hasUserId: !!userId,
      hasMessageId: !!messageId
    })
    
    if (!userId) {
      console.error('[useNotification] User ID is missing! Cannot send remove-message request.')
      // Закрываем уведомление даже если нет user_id
      notificationMessage.value = null
      notificationMessageId.value = null
      notificationUserId.value = null
      return
    }
    
    if (!messageId) {
      console.warn('[useNotification] Message ID is missing, closing notification without API call')
      notificationMessage.value = null
      notificationMessageId.value = null
      notificationUserId.value = null
      return
    }
    
    try {
      // Убеждаемся, что user_id и message_id передаются как строки
      const userIdStr = String(userId)
      const messageIdStr = String(messageId)
      
      console.log('[useNotification] Sending removeMessage request with:', {
        user_id: userIdStr,
        message_id: messageIdStr
      })
      
      const response = await apiService.removeMessage(userIdStr, messageIdStr)
      console.log('[useNotification] removeMessage response:', response)
      
      if (!response.ok) {
        console.error('[useNotification] removeMessage failed:', response)
      } else {
        console.log('[useNotification] Message successfully removed from backend')
      }
    } catch (error) {
      console.error('[useNotification] Error removing message from backend:', error)
    }
    
    // Закрываем уведомление в любом случае
    notificationMessage.value = null
    notificationMessageId.value = null
    notificationUserId.value = null
  }

  return {
    notificationMessage,
    notificationMessageId,
    checkForMessages,
    closeNotification
  }
}

